
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VeeValidate from 'vee-validate';

import './assets/polyfills/polyfills';

import App from './App';
import store from './common/store';
import router from './common/router/router';

import Vue2TouchEvents from 'vue2-touch-events';

import UtilitiesPlugin from './common/plugins/UtilitiesPlugin';
import TranslationPlugin from './common/plugins/TranslationPlugin';
import AjaxHelperPlugin from './common/plugins/AjaxHelperPlugin';
import PfChatbotPlugin from "./common/plugins/pathfinder/PfChatbotPlugin";
import PfChatbotChooseMainSymptomPlugin from "./common/plugins/pathfinder/PfChatbotChooseMainSymptomPlugin";
import SvgPlugin from "./common/plugins/svg/SvgPlugin"
import DecisionItemHelperPlugin from "./common/plugins/DecisionItemHelperPlugin";

/* load global app style */
require('./assets/styles/scss/global.scss');
require('./assets/styles/scss/pathfinder/chatbot.scss');

require('./assets/styles/scss/summary.scss');

Vue.config.productionTip = false;

Vue.use(Vuetify, {
    theme: {
        // primary: '#63a43a',
        // secondary: '#FFCDD2', // #FFCDD2
        // accent: '#4b0082', // #3F51B5
    }
});
Vue.use(VeeValidate);
Vue.use(Vue2TouchEvents);

Vue.use(UtilitiesPlugin, {router, store});
Vue.use(TranslationPlugin, {router, store});
Vue.use(AjaxHelperPlugin, {router, store});
Vue.use(DecisionItemHelperPlugin, {router, store});
Vue.use(PfChatbotPlugin, {router, store});
Vue.use(PfChatbotChooseMainSymptomPlugin, {router, store});
Vue.use(SvgPlugin, {router, store});

// ----- Create Vue instance -----

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: router,
    store: store,
    components: { App },
    template: '<App/>'
});



router.beforeEach((to, from, next) => {

    if (from.name === 'PF_GeneralQuestionsPage' && to.name ==='PF_StartQuestionsPage') {
        router.app.$store.commit("PfAssessmentStartStore/setBackFromGeneral", true);
    } else {
        router.app.$store.commit("PfAssessmentStartStore/setBackFromGeneral", false);
    }

    if (to.name !== 'AssessmentSharePage') {
        sessionStorage.removeItem('proMsitatForAssessmentShare');
    }

    if (from.name === 'PF_ChatbotAssessmentSharePage' && to.name ==='PF_ChatBotEvaluationPage') {

        let setRouteCookie = (name,value, days) => {
            let expires = "";
            let date = new Date();
            if (days) {
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires +"; path=/";
        };

        setRouteCookie('showAssessmentAlert', "no", 366);
    }


    if (router.app.$store.getters["UserStore/getCurrentAppType"] === router.app.$store.getters["UserStore/getAppTypes"].PF_CHATBOT_STUDY) {

        if (to.name !== "PF_ChatBotPage" && to.name !== "BlankPage") {
            if (router.app.$store.getters["UserStore/getIsUserLoggedIn"] === true) {
                next({
                    name: 'PF_ChatBotPage'
                });
            }
            else {
                next({
                    name: 'BlankPage'
                });
            }
        }
        else {
            next();
        }
    }
    else if (router.app.$store.getters["UserStore/getCurrentAppType"] === router.app.$store.getters["UserStore/getAppTypes"].PF_CHATBOT) {
        if ( router.app.$store.getters["UserStore/getIsUserLoggedIn"] && to.path === '/' ) {
            next({
                name: 'PF_ChatBotPage'
            });
        }
        else {
            next();
        }
    }

    else if(router.app.$store.getters["UserStore/getCurrentAppType"] === router.app.$store.getters["UserStore/getAppTypes"].PF_CHATBOT_PUBLIC) {

        let chatbotRoutesForAuthUsers = [
            "PF_ChatBotPage",
            "PF_AssessmentPage",
            "BlankPage",
            "PF_ChatBotEvaluationPage",
            "PF_ChatbotAssessmentSharePage",
            "DocPage"
        ];

        if (!chatbotRoutesForAuthUsers.includes(to.name)) {

            if (router.app.$store.getters["UserStore/getIsUserLoggedIn"] === true) {
                next({
                    name: 'PF_ChatBotPage',
                })
            }
            else {
                console.log('User Not Logged In ...');
                window.location.replace(window.location.origin + window.location.pathname);
            }
        }
        else {
            next();
        }
    }
    else {
        if ( router.app.$store.getters["UserStore/getUsername"] !== '' && to.path === '/' ) {

            if (typeof to.query.assessment !== "undefined") {

                if (typeof to.query.version !== "undefined") {
                    next({
                        path: '/summary?assessment='+ to.query.assessment+ '&version='+ to.query.version
                    });
                }
                else {
                    next({
                        path: '/summary?assessment='+ to.query.assessment
                    });
                }
            }
            else {
                let sessionStorageHomeRouteName = sessionStorage.getItem("smass-home-route");
                if (sessionStorageHomeRouteName !== null && sessionStorageHomeRouteName === "PF_ChatBotPage") {
                    // Go to PATHFINDER
                    next({name: 'PF_ChatBotPage'});

                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                }
                else {
                    // Go to PRO
                    next({name: 'HomePage'});
                }
            }
        } else {
            next();
        }
    }


});



// WEBPACK FOOTER //
// ./src/main.js